/* Product page jump bar (sections/product-jump.liquid). Finds each pill's section by the section key (the wrapper's id ends with __<key>), hides pills whose
   section isn't on this page (a section that printed nothing has no height), scrolls below the sticky header + this bar on click, moves focus to the
   section, and marks the pill of the section being read (aria-current="location"). Smooth scrolling only without prefers-reduced-motion. */
(function () {
  var nav = document.querySelector('[data-product-jump]');
  if (!nav) return;
  var list = nav.querySelector('.pj__list');
  var pills = Array.prototype.slice.call(nav.querySelectorAll('[data-pj-keys]'));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [];

  function findSection(keys) {
    var parts = keys.split(',');
    for (var i = 0; i < parts.length; i++) {
      var key = parts[i].trim();
      if (!key) continue;
      var el = document.querySelector('[id$="__' + key + '"]');
      if (el && el.getBoundingClientRect().height > 40) return el;
    }
    return null;
  }

  function offset() {
    var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 80;
    return h + nav.getBoundingClientRect().height + 8;
  }

  function build() {
    items = [];
    pills.forEach(function (pill) {
      var el = findSection(pill.getAttribute('data-pj-keys'));
      pill.parentElement.hidden = !el;
      if (el) items.push({ pill: pill, el: el });
    });
    // Nothing worth jumping to (fewer than two targets): keep the bar hidden.
    nav.hidden = items.length < 2;
    update();
  }

  function update() {
    if (nav.hidden) return;
    var line = offset() + 24, current = null;
    items.forEach(function (it) { if (it.el.getBoundingClientRect().top <= line) current = it; });
    items.forEach(function (it) {
      if (it === current) it.pill.setAttribute('aria-current', 'location'); else it.pill.removeAttribute('aria-current');
    });
    if (current && list.scrollWidth > list.clientWidth) {
      var p = current.pill, left = p.offsetLeft - (list.clientWidth - p.offsetWidth) / 2;
      list.scrollLeft = Math.max(0, left);
    }
  }

  nav.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-pj-keys]');
    if (!pill) return;
    var it = items.filter(function (x) { return x.pill === pill; })[0];
    if (!it) return;
    e.preventDefault();
    var top = it.el.getBoundingClientRect().top + window.pageYOffset - offset();
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    it.el.setAttribute('tabindex', '-1');
    it.el.focus({ preventScroll: true });
  });

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });

  build();
  window.addEventListener('load', build);
})();
